module.exports = __webpack_public_path__ + "static/media/water-supply-3-fg.102d82e1.png";